module.exports = __webpack_public_path__ + "media/images/lp_03-7a85abd23f53575073beeef2cb415d03.webp";